<div style="padding-left: 10px">
  <oph-button
    color="orange"
    class="add-subtask-button"
    [style]="{width: '157px', height: '30px', fontSize: '14px', borderRadius: '6px'}"
    (buttonClick)="newSubtask.emit()"
  >
    <mat-icon svgIcon="plus"></mat-icon>
    <span>New Subtask</span>
  </oph-button>
</div>

<div cdkDropList class="subtasks-list" [cdkDropListAutoScrollDisabled]="false" (cdkDropListDropped)="onDrop($event)">
  @if ({hoverIndex: hoverIndex$ | async}; as state) {
    @for (subtask of (subtasks$ | async) || []; track subtask; let i = $index) {
      <div class="subtask-container" cdkDrag (mouseenter)="onMouseEnter(i)" (mouseleave)="onMouseLeave(i)">
        <div
          class="subtask-item"
          [class.subtask-item-light]="itemBackground === 'light'"
          [class.subtask-item-dark]="itemBackground === 'dark'"
          (click)="onEdit(i)"
        >
          <mat-icon svgIcon="subtask" class="subtask-icon"></mat-icon>
          <div class="subtask-item-title">
            {{ subtask.title || $any(subtask).description || '(Edit to update subtask title)' }}
          </div>
          @if (i === state.hoverIndex) {
            <div cdkDragHandle class="drag-handle" (click)="$event.stopPropagation()">
              <div class="drag-handle-inner-container">
                <div class="white-line white-line-top"></div>
                <div class="white-line white-line-bottom"></div>
                <img src="assets/img/icons/up-down-arrows.svg" />
              </div>
            </div>
          }
          <div class="subtask-menu-container" (click)="$event.stopPropagation()">
            <list-view-menu [options]="menuOptions" (action)="onMenuAction($event, i)"></list-view-menu>
          </div>
        </div>
      </div>
    }
  }
</div>
